import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import Swal from 'sweetalert2';
import { LoginResponse } from './models/login-response';

// assuming default export
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.API_URL;
  constructor(private http: HttpClient, private router: Router) { }

  login(username: string, password: string): Observable<any> {
    const url = `${this.baseUrl}/api/v1/login`;
    const body = { username, password };
    return this.http.post<any>(url, body);
  }

  getUserInfo(): Observable<any> {
    const url = `${environment.API_URL}/api/v1/users/info`;
    return this.http.get(url);
  }

  getCurrentUserRole(): string {
    const role = localStorage.getItem('userRole');
    if (role) {
      try {
        return JSON.parse(role);
      } catch (e) {
        return role;
      }
    } else {
      return '';
    }
  }

  refreshToken(): Observable<any> {
    const url = `${environment.API_URL}/api/v1//token/refresh`;
    const refreshToken = this.getRefreshToken();
    const body = { refresh_token: refreshToken };
    return this.http.post<any>(url, body);
  }

  getToken(): string {
    return localStorage.getItem('token') || '';
  }

  getRefreshToken(): string {
    return localStorage.getItem('refresh_token') || '';
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('email');
    this.router.navigate(['/login']);
  }

  getUserRole(): Observable<string> {
    const role = localStorage.getItem('userRole');
    return of(role as string);
  }

}
